import type { Effect, Reducer, Subscription } from '@umijs/max';
import {
  getShopOperatorPage,
  addShopOperator,
  editShopOperator,
  removeShopOperator,
} from './service';

type ShopOperatorListModelType = {
  namespace: 'shopOperatorList';
  state: API.ShopOperatorListState;
  effects: {
    fetchShopOperatorPageEffect: Effect;
    refreshDataEffect: Effect;
    addShopOperatorEffect: Effect;
    editShopOperatorEffect: Effect;
    removeShopOperatorEffect: Effect;
  };
  reducers: {
    setPageData: Reducer<API.ShopOperatorListState>;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const ShopOperatorListModel: ShopOperatorListModelType = {
  namespace: 'shopOperatorList',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    fetchShopOperatorPageEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopOperatorPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    refreshDataEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopOperatorPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    addShopOperatorEffect: function* ({ payload, callback }, { call, put }) {
      const res = yield call(addShopOperator, payload.values);
      if (res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: {
            filter: payload.filter,
            page: payload.page,
            limit: payload.limit,
            sorter: payload.sorter,
          },
        });
      }
      callback?.(res);
    },

    editShopOperatorEffect: function* ({ payload, callback }, { call, put }) {
      const res = yield call(editShopOperator, payload.values);
      if (res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: {
            filter: payload.filter,
            page: payload.page,
            limit: payload.limit,
            sorter: payload.sorter,
          },
        });
      }
      callback?.(res);
    },

    removeShopOperatorEffect: function* ({ payload, callback }, { call, put }) {
      const res = yield call(removeShopOperator, payload.values);
      if (res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: {
            filter: payload.filter,
            page: payload.page,
            limit: payload.limit,
            sorter: payload.sorter,
          },
        });
      }
      callback?.(res);
    },
  },

  reducers: {
    setPageData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/shopManage/shopOperator') {
          // 页面初始化时不自动加载数据，由组件控制
        }
      });
    },
  },
};

export default ShopOperatorListModel;
